var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MenuMultiSelectItem, SearchableMenuMultiSelectList, SearchableMenuControlled, } from 'shared/domains/common-ui/SearchableMenu';
import { useProjectSearch } from './useProjectSearch';
import { ProjectDetailsPopover } from '../ProjectDetailsPopover';
import { ProjectDialog } from '../ProjectDialog';
export function SelectProjectsMenu(props) {
    const { initiallyOpen, renderTarget, selectedProjectIds, isProjectDisabled, onClose, onSelect, loading } = props;
    const [loadingProjectId, setLoadingProjectId] = useState(null);
    const { search, setSearch, searchResults, loading: searchLoading, error, clearSearch, } = useProjectSearch(selectedProjectIds);
    const [renderCreateDialog, setRenderCreateDialog] = useState(false);
    const showCreateDialog = () => setRenderCreateDialog(true);
    const hideCreateDialog = () => setRenderCreateDialog(false);
    const handleProjectCreated = () => {
        hideCreateDialog();
        clearSearch();
    };
    const handleSelect = (project) => __awaiter(this, void 0, void 0, function* () {
        setLoadingProjectId(project.id);
        yield onSelect(project);
        setLoadingProjectId(null);
    });
    const isLoading = loading || searchLoading;
    return (<Fragment>
      {renderCreateDialog && (<ProjectDialog initialValues={{ name: search }} onClose={hideCreateDialog} onSubmit={handleProjectCreated}/>)}

      <SearchableMenuControlled items={searchResults} onSearch={setSearch} onReset={clearSearch} initiallyOpen={initiallyOpen} onClose={onClose} renderTarget={renderTarget} loading={isLoading} error={Boolean(error)} placeholder={t({
            message: 'Search projects',
            comment: 'Select projects menu - search input placeholder',
        })}>
        <Menu.Item onClick={showCreateDialog}>
          <Falcon icon="plus"/>
          <Trans comment="New project menu item title">New project</Trans>
        </Menu.Item>
        <SearchableMenuMultiSelectList selected={selectedProjectIds} renderListWrapper={false} renderItem={(item) => (<ProjectDetailsPopover projectId={item.id}>
              <MenuMultiSelectItem disabled={isProjectDisabled ? isProjectDisabled(item) : false} loading={loadingProjectId === item.id} onClick={() => handleSelect(item)} selected={selectedProjectIds.includes(item.id)}>
                <Menu.ItemText primary={item.name}/>
              </MenuMultiSelectItem>
            </ProjectDetailsPopover>)}/>
      </SearchableMenuControlled>
    </Fragment>);
}
